import { useEffect, useRef, useState } from "react";

/** Excel-like editable numeric/text cell. Commits on blur/enter.
 *  Does NOT overwrite the user's in-progress text while the field is focused. */
export default function Cell({ value, onChange, type = "number", step, testid, className = "", disabled }) {
  const [local, setLocal] = useState(value ?? "");
  const focused = useRef(false);

  useEffect(() => { if (!focused.current) setLocal(value ?? ""); }, [value]);

  const commit = () => {
    focused.current = false;
    if (type === "number") {
      const n = local === "" || local === "-" ? 0 : parseFloat(local);
      onChange(isNaN(n) ? 0 : n);
    } else {
      onChange(local);
    }
  };

  return (
    <input
      data-testid={testid}
      disabled={disabled}
      className={`cell-input ${type === "text" ? "text-left" : ""} ${className} ${disabled ? "opacity-70 cursor-not-allowed" : ""}`}
      value={local}
      step={step}
      onFocus={() => { focused.current = true; }}
      onChange={(e) => setLocal(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => { if (e.key === "Enter") e.target.blur(); }}
    />
  );
}
